<mat-form-field *ngIf="control" class="app-datepicker">
  <mat-label>{{label}}</mat-label>
  <input matInput [matDatepicker]="dp" [formControl]="control" [required]="required"
         placeholder="01/01/2001"
         autocomplete="off">
  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker #dp></mat-datepicker>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
</mat-form-field>
